import { render, staticRenderFns } from "./OldMallItem.vue?vue&type=template&id=1b8f96d8&scoped=true"
import script from "./OldMallItem.vue?vue&type=script&lang=js"
export * from "./OldMallItem.vue?vue&type=script&lang=js"
import style0 from "./OldMallItem.vue?vue&type=style&index=0&id=1b8f96d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8f96d8",
  null
  
)

export default component.exports